import { MAX_PASSWORD_CHAR } from "utils/Constants";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// antd validation, use this one
export const requiredRule = { required: true, message: "Required" };

export const emailRule = {
  required: false,
  type: "email",
  message: "Not a valid email"
};

export const alphanumericRule = {
  validator: (_: any, str: string): Promise<void> => {
    return /^[a-zA-Z0-9]*$/.test(str)
      ? Promise.resolve()
      : Promise.reject("Only alphanumeric characters allowed");
  }
};

export const alphanumericDashRule = {
  validator: (_: any, str: string): Promise<void> => {
    return !str || /^[\sa-zA-Z0-9-]*$/.test(str)
      ? Promise.resolve()
      : Promise.reject("Only alphanumeric characters allowed");
  }
};

export const alphabeticalRule = {
  validator: (_: any, str: string): Promise<void> => {
    return !str || /^[\sa-zA-Z-']*$/.test(str)
      ? Promise.resolve()
      : Promise.reject("Only alphabetical characters allowed");
  }
};

export const urlRule = {
  validator: (_: any, str: string): Promise<void> => {
    if (!str) {
      return Promise.resolve();
    }

    // http protocol prefix is included in a select field
    if (/^https?:\/\//.test(str)) {
      return Promise.reject("Do not include the 'http(s)://' prefix");
    }

    try {
      new URL(`https://${str}`);
      return Promise.resolve();
    } catch {
      return Promise.reject("Url is not valid.");
    }
  }
};

export const onlyNumberRule = {
  validator: (_: any, str: string): Promise<void> => {
    return !str || /^[0-9]*$/.test(str)
      ? Promise.resolve()
      : Promise.reject("Only numbers are allowed");
  }
};

const createRules = (
  action: (valid: boolean) => any,
  test: (str: string) => { valid: boolean; required: boolean },
  message?: string
) => {
  return {
    validator: (_: any, str: string): Promise<void> => {
      const { valid, required } = test(str);
      const isValidationPassed = valid && required;
      action(isValidationPassed);
      return isValidationPassed
        ? Promise.resolve()
        : Promise.reject(!required ? "Required" : message || "Invalid. Please check your input");
    }
  };
};

export const createOnlyNumberRule = (action: (valid: boolean) => any) =>
  createRules(action, str => ({ valid: /^[0-9]*$/.test(str), required: true }));

export const createRequiredRule = (action: (valid: boolean) => any) =>
  createRules(action, str => ({ valid: true, required: str.trim().length > 0 }));

export const createRequiredOnlyNumberRule = (action: (valid: boolean) => any) =>
  createRules(action, str => ({ valid: str ? /^[0-9]*$/.test(str) : true, required: true }));

export const createRequiredEmailRule = (action: (valid: boolean) => any) =>
  createRules(action, str => ({
    valid: /^\w+([!#$%&'*+-/=?^_`{|]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str),
    required: str.trim().length > 0
  }));

export const max64CharRule = {
  validator: (_: any, str: string): Promise<void> => {
    return str.trim().length <= MAX_PASSWORD_CHAR
      ? Promise.resolve()
      : Promise.reject("Your password cannot be longer than 64 characters");
  }
};
